import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';

import { translate as t } from '../../lib/I18n';
import ModalActions from '../../actions/ModalActions';

import BaseModal from './BaseModal';

class BrandSplitSuccess extends React.PureComponent {

    static propTypes = {
        brand: PropTypes.string
    };

    static defaultProps = {
        brand: ''
    };

    handleCancel = () => {
        ModalActions.close();
    };

    render () {
        const logo = `/images/logos/${this.props.brand}-logo-mobile.png`;
        const modalProps = {
            disableEscape: true,
            titleText: 'brand.split.success',
            closeText: 'button.text.close',
            onClose: this.handleCancel,
            hideContinue: true,
            className: "modal--sm"
        };

        return (
            <BaseModal { ...modalProps }>
                <div className="vertical-align-parent full-height">
                    <div className={ classnames('success text-center') }>
                        <p className="text-secondary text-weight--normal">{ t('brand.split.message') }</p>
                        <img src={ logo } alt={ this.props.brand } />
                    </div>
                </div>
            </BaseModal>
        );
    }
}

export default BrandSplitSuccess;
